const config = {
  baseApiUrl: process.env.REACT_APP_API_URL,
  googleClientId: process.env.REACT_APP_GOOGLE_CLIENT_ID,
  facebookAppId: process.env.REACT_APP_FACEBOOK_APP_ID
};

export default config;